/**
 * 白名单列表。
 * webim部分功能仅适用于白明单主号。因此配置都放这里。
 */
export const WHITE_LIST = {
  // 不加载历史纪录。需求来源 华为2885820057，用户退出webim后不显示历史消息。
  // 在老webim中，是在 unload事件中清理 kfuin+vid 对应的所有本地消息实现的。新webim通过不拉取历史消息实现。
  NOT_LOAD_HISTORY_MSG: [2885820057],
  // 使用【在线客服】作为默认title。需求来源金茂3009112396。
  USE_DEFAULT_TITLE: [3009112396],
};

// 测试主号
let TEST_KFUIN = 0;
try {
  TEST_KFUIN = Number(localStorage.getItem('qdim_whitelist_test_kfuin'));
} catch (ex) {
  console.error('[whiteList] localStorage set error');
}

/**
 * 检查主号是否在指定的白名单中
 * @param kfuin 主号
 * @param key 要检查的key
 * @returns
 */
export function isInWhiteList(kfuin, key) {
  if (!kfuin) {
    return false;
  }

  const kfn = kfuin - 0;
  // 测试白名单主号
  if (kfn === TEST_KFUIN) {
    console.warn(`======>[whiteList][TEST][${kfn}]`);
    return true;
  }

  if (WHITE_LIST[key].indexOf(kfn) > -1) {
    console.warn(`======>[whiteList][${key}][${kfn}]`);
    return true;
  }

  return false;
}
